import { render, staticRenderFns } from "./contractStatis.vue?vue&type=template&id=39fa9d20&"
import script from "./contractStatis.vue?vue&type=script&lang=js&"
export * from "./contractStatis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports